import { render, staticRenderFns } from "./FormProductDiscountComponent.vue?vue&type=template&id=20358e8a"
import script from "./FormProductDiscountComponent.vue?vue&type=script&lang=js"
export * from "./FormProductDiscountComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductDiscountComponent.vue?vue&type=style&index=0&id=20358e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports